export const LIST = "EVENT_QNA_SETTING_LIST";
export const SETTING_DATA = "EVENT_QNA_SETTING_DATA";
export const CREATE = "EVENT_QNA_SETTING_CREATE";
export const UPDATE = "EVENT_QNA_SETTING_UPDATE";